import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_COMPETITION,
  SET_COMPETITION,
  SET_ERROR,
} from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  id: null,
  name: null,
  logoUrl: null,
  themeColor1: null,
  themeColor2: null,
  color: null,
  isCup: null,
  banner: [],
  season: null,
  gameWeek: null,
  matchPageSize: null,
  isSuperCup: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPETITION:
      return {
        ...state,
        id: action.data.id,
        name: action.data.name,
        logoUrl: action.data.logoUrl,
        themeColor1: action.data.themeColor1,
        themeColor2: action.data.themeColor2,
        isCup: action.data.isCup,
        banner: action.data.banner,
        color: action.data.color,
        season: action.data.season,
        gameWeek: action.data.gameWeek,
        matchPageSize: action.data.matchPageSize,
        isSuperCup: action.data.isSuperCup,
        isReady: true,
        isError: false,
      };
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    case RESET_COMPETITION:
      return initialState;
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectCompetition = createSelector(getState, (n) => ({
  id: n.id,
  name: n.name,
  logoUrl: n.logoUrl,
  themeColor1: n.themeColor1,
  themeColor2: n.themeColor2,
  isCup: n.isCup,
  color: n.color,
  banner: n.banner,
  season: n.season,
  gameWeek: n.gameWeek,
  matchPageSize: n.matchPageSize,
  isSuperCup: n.isSuperCup,
}));

reducerRegistry.register(REDUCER_NAME, reducer);
